import { JogId } from ".";
import { JogsForAllWspEventsRequest } from "./wsp-fake-agencies";

export const JogIdConversionMap = new Map<string, JogId>([
  ["0", JogId.Other],
  ["1", JogId.SeattleArea],
  ["2", JogId.KingCountyNortheast],
  ["3", JogId.KingCountySouth],
  ["4", JogId.Tacoma],
  ["5", JogId.JBLM],
  ["6", JogId.SnohomishCounty],
  ["7", JogId.KitsapPeninsula],
  ["8", JogId.ClarkCounty],
]);

export const sanitizeJogIds = (jogIds: string): string => {
  let jogIdSet = new Set(jogIds.split(","));
  // Delete these just in case they were somehow added.
  if (jogIdSet.has(JogId.Other)) jogIdSet.delete(JogId.Other);
  if (jogIdSet.has(JogId.NOT_SELECTED)) jogIdSet.delete(JogId.NOT_SELECTED);

  if (jogIdSet.has(JogId.Wsp)) {
    // Delete fake JOG ID
    jogIdSet.delete(JogId.Wsp);

    // Add all needed real JOG IDs
    // ...to retrieve WSP events and any incidents for all WSP districts.    
    JogsForAllWspEventsRequest.forEach(jogId => jogIdSet.add(jogId));    
  }
  
  return [...jogIdSet.values()].join(",");
}